export default __webpack_public_path__ + "static/media/redassetmegawide.6aa562cc.PNG";